import { useLogPostHogEvent } from '@hcs/posthog';
import {
  EngagementEvent,
  MeaningfulEventTypes,
  PostHogEventData,
} from '@hcs/types';

export const useTrackPostHogEvent = () => {
  const logPostHogEvent = useLogPostHogEvent();
  const trackPostHogEvent = (engagementEvent: EngagementEvent) => {
    // only track goal events
    if (
      engagementEvent.event_type === MeaningfulEventTypes.Goal &&
      engagementEvent.event_data
    ) {
      const {
        device,
        event_section,
        plan_id,
        canceled_subscription,
        plan,
        upcoming_self_serve_plan,
      } = engagementEvent.event_data;

      const postHogEventData: PostHogEventData = {
        browser: device?.browser,
        browserVersion: device?.browser_version,
        os: device?.os,
        osVersion: device?.os_version,
        eventSection: event_section,
        subscriptionType: engagementEvent.subscription_type,
        planId: plan_id,
        plan,
        canceledSubscription: canceled_subscription,
        upcomingSelfServePlan: upcoming_self_serve_plan,
        eventType: engagementEvent.event_type,
        httpPath: engagementEvent.http_path,
        httpReferer: engagementEvent.http_referer,
      };
      logPostHogEvent(engagementEvent.event_name, postHogEventData);
    }
  };
  return {
    mutate: trackPostHogEvent,
  };
};
